import { render, staticRenderFns } from "./sign-form.vue?vue&type=template&id=4f5db926&scoped=true&"
import script from "./sign-form.vue?vue&type=script&lang=js&"
export * from "./sign-form.vue?vue&type=script&lang=js&"
import style0 from "./sign-form.vue?vue&type=style&index=0&id=4f5db926&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5db926",
  null
  
)

export default component.exports